import { ROLE, parseCommaSeparatedList } from '@talos/kyoko';

/**
 * All valid ROLE enum values as an array for runtime validation
 */
const VALID_ROLES = Object.values(ROLE);

/**
 * Type guard to check if a string is a valid ROLE
 */
export function isValidRole(value: string): value is ROLE {
  return VALID_ROLES.includes(value as ROLE);
}

/**
 * Parse roles from either a comma-separated string or string array and return only valid ROLE values
 * @param rolesInput - Comma-separated string of roles or array of strings
 * @returns Array of valid ROLE values, or undefined if no valid roles found
 */
export function parseRoles(rolesInput: string | string[] | undefined | null): ROLE[] | undefined {
  if (!rolesInput) {
    return undefined;
  }

  // Handle string input by parsing comma-separated values
  const roles = typeof rolesInput === 'string' ? parseCommaSeparatedList(rolesInput) : rolesInput;

  if (roles.length === 0) {
    return undefined;
  }

  const validRoles = roles.filter(isValidRole);
  return validRoles.length > 0 ? (validRoles as ROLE[]) : undefined;
}
